<template>
  <div class="col left-navbar-container d-none d-sm-block">
    <div class="left-navbar pt-5">
      <ul>
        <li id="leader" :class="{ active: isLeader }">
          <router-link :to="{ name: 'competitorLeader'}" class="icon-container">
            <i class="material-icons">thumb_up</i>
            <p class="d-none d-sm-inline"> Price leader</p>
          </router-link>
        </li>
        <li id="rates" :class="{ active: isRates }">
          <router-link :to="{ name: 'competitorRates'}" class="icon-container">
            <i class="material-icons">search</i>
            <p class="d-none d-sm-inline"> Compare</p>
          </router-link>
        </li>
        <li id="update-rates" :class="{ active: isUpdateRates }">
          <router-link :to="{ name: 'competitorUpdateRates'}" class="icon-container">
            <i class="material-icons">update</i>
            <p class="d-none d-sm-inline"> Update</p>
          </router-link>
        </li>
        <li id="apps" :class="{ active: isApps }">
          <router-link :to="{ name: 'competitorApps'}" class="icon-container">
            <i class="material-icons">star</i>
            <p class="d-none d-sm-inline"> App ratings</p>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CompetitorLeftNav',
  mounted () {
    this.isApps = this.$route.name === 'competitorApps'
    this.isRates = this.$route.name === 'competitorRates'
    this.isLeader = this.$route.name === 'competitorLeader'
    this.isUpdateRates = this.$route.name === 'competitorUpdateRates'
  },
  data () {
    return {
      isApps: false,
      isRates: false,
      isLeader: false,
      isUpdateRates: false
    }
  }
}
</script>

<style lang="scss" scoped>
.left-navbar-container {
  min-height: calc(100vh - 60px);
  padding: 0;
  max-width: 200px;
}

.left-navbar {
  position: fixed;
  width: 200px;
  background-color: rgb(65, 72, 81);
  color: rgb(255, 255, 255);
  height: calc(100vh - 60px);

  ul {
    padding: 0;

    &.push-bottom {
      position: absolute;
      bottom: 0;
    }

    li {
      list-style: none;

      &:hover {
        background-color: rgb(106, 111, 118);
      }

      a {
        color: #FFFFFF;
        padding: 30px;
        display: block;
        width: 100%;
        height: 100%;

        &:hover {
          text-decoration: none;
        }
      }

      &.active {
        background-color: rgb(106, 111, 118);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/CompetitorLeftNav.vue